import React, { useRef, useState } from "react";

import useEsTelefono from "../../../../utils/esTelefono";

import HttpManager from "../../../../services/HttpManager";
import { AttendeeKind, EventAttendeeDTO, EventDetailDTO } from "../../../../models/EventDTO";
import S from "./strings";
import { BuscarAlumna, Modal, PromptModal, blobErrorText, dinero, errorText, guardarBlob, horaLocal } from "../workshops/comun";

interface Props { campusId: number; evento: EventDetailDTO; soloLectura: boolean; reload: () => void; notify: (t: string, ok?: boolean) => void; }

const slug = (t: string) => t.normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^A-Za-z0-9]+/g, "_").replace(/^_|_$/g, "");

/** Alta de graduada, invitado, especial o externo. */
const AgregarModal: React.FC<{ campusId: number; evento: EventDetailDTO; onClose: () => void; onDone: () => void }> = ({ campusId, evento, onClose, onDone }) => {
	const http = HttpManager.getInstance();
	const graduadas = evento.attendees.filter(a => a.status === 1 && a.kind === "graduada");
	const [kind, setKind] = useState<AttendeeKind>(graduadas.length ? "invitado" : "graduada");
	const [alumna, setAlumna] = useState<{ id: number; name: string } | null>(null);
	const [name, setName] = useState<string>("");
	const [host, setHost] = useState<number>(0);
	const [isChild, setIsChild] = useState<boolean>(false);
	const [tableNo, setTableNo] = useState<string>("");
	const [cobra, setCobra] = useState<boolean>(true);
	const [price, setPrice] = useState<string>("");
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const valido = kind === "graduada" ? !!alumna : kind === "invitado" ? host > 0 && name.trim().length > 1 : (!!alumna || name.trim().length > 1);
	const guardar = () => {
		setBusy(true); setError(null);
		http.eventsService.addAttendee(campusId, {
			eventId: evento.id, kind, studentId: alumna && (kind === "graduada" || kind === "especial") ? alumna.id : undefined,
			name: name.trim() || undefined, hostAttendeeId: kind === "invitado" ? host : undefined, isChild: kind === "invitado" ? isChild : undefined,
			tableNo: tableNo.trim() || undefined, charge: kind === "graduada" || kind === "invitado" ? cobra : undefined,
			price: price.trim() !== "" ? Number(price) : undefined
		}).then(onDone).catch(e => { setError(errorText(e)); setBusy(false); });
	};
	return (
		<Modal title={S.agregarAsistente} onClose={onClose} ancho={560}>
			<div className="wau-chips" role="group">
				{(["graduada", "invitado", "especial", "externo"] as AttendeeKind[]).map(k => (
					<button key={k} type="button" className="wau-chip" aria-pressed={kind === k} onClick={() => { setKind(k); setAlumna(null); }}>{S.kinds[k]}</button>
				))}
			</div>
			{kind === "graduada" || kind === "especial" ? (
				alumna ? <div className="wau-wa"><b>{alumna.name}</b><button type="button" className="wau-btn s mini" onClick={() => setAlumna(null)}>{S.quitar}</button></div>
					: <div style={{ marginBottom: 10 }}><BuscarAlumna campusId={campusId} onPick={setAlumna} placeholder={S.buscarAlumna} boton={S.buscarBtn} /></div>
			) : null}
			{kind === "invitado" ? (
				<label className="wau-campo" style={{ marginBottom: 10 }}><span className="wau-lab">{S.invitaGraduada}</span>
					<select className="wau-entrada" value={host} onChange={e => setHost(Number(e.target.value))}>
						<option value={0}>{S.elegir}</option>
						{graduadas.map(g => <option key={g.id} value={g.id}>{g.name}</option>)}
					</select></label>
			) : null}
			{kind !== "graduada" && !(kind === "especial" && alumna) ? (
				<label className="wau-campo" style={{ marginBottom: 10 }}><span className="wau-lab">{S.colNombre}</span>
					<input className="wau-entrada" value={name} onChange={e => setName(e.target.value)} /></label>
			) : null}
			<div className="wau-fila" style={{ marginBottom: 10 }}>
				{kind === "invitado" ? <label className="wau-campo" style={{ flexDirection: "row", alignItems: "center", gap: 6 }}><input type="checkbox" checked={isChild} onChange={e => setIsChild(e.target.checked)} /><span>{S.esNino}</span></label> : null}
				{kind === "graduada" || kind === "invitado" ? <label className="wau-campo" style={{ flexDirection: "row", alignItems: "center", gap: 6 }}><input type="checkbox" checked={cobra} onChange={e => setCobra(e.target.checked)} /><span>{S.seCobra}</span></label> : null}
				{(kind === "graduada" || kind === "invitado") && cobra ? (
					<label className="wau-campo" style={{ width: 130 }}><span className="wau-lab">{S.precio}</span>
						<input type="number" min={0} step="0.01" className="wau-entrada wau-num" value={price} placeholder={String(kind === "graduada" ? evento.packagePrice : isChild ? evento.childPrice : evento.extraGuestPrice)} onChange={e => setPrice(e.target.value)} /></label>
				) : null}
				{kind === "externo" ? (
					<label className="wau-campo" style={{ width: 130 }}><span className="wau-lab">{S.precio}</span>
						<input type="number" min={0} step="0.01" className="wau-entrada wau-num" value={price} onChange={e => setPrice(e.target.value)} /></label>
				) : null}
				<label className="wau-campo" style={{ width: 90 }}><span className="wau-lab">{S.colMesa}</span>
					<input className="wau-entrada wau-num" maxLength={10} value={tableNo} onChange={e => setTableNo(e.target.value)} /></label>
			</div>
			{error ? <p className="wau-adv">{error}</p> : null}
			<div className="wau-acciones">
				<button type="button" className="wau-btn s" onClick={onClose} disabled={busy}>{S.volver}</button>
				<button type="button" className="wau-btn p" onClick={guardar} disabled={busy || !valido}>{S.agregarBtn}</button>
			</div>
		</Modal>
	);
};

/** Asistentes: no., tipo, mesa, pago, foto, invitación y diploma en PDF, baja. */
const AsistentesTab: React.FC<Props> = ({ campusId, evento, soloLectura, reload, notify }) => {
	const http = HttpManager.getInstance();
	const [agregar, setAgregar] = useState<boolean>(false);
	const [baja, setBaja] = useState<EventAttendeeDTO | null>(null);
	const [busy, setBusy] = useState<boolean>(false);
	const [fotoDe, setFotoDe] = useState<EventAttendeeDTO | null>(null);
	const [verFoto, setVerFoto] = useState<{ nombre: string; url: string } | null>(null);
	const archivo = useRef<HTMLInputElement>(null);
	const vigentes = evento.attendees.filter(a => a.status === 1);
	const movil = useEsTelefono();

	const pdf = (a: EventAttendeeDTO, tipo: "invitacion" | "diploma") => {
		const req = tipo === "invitacion" ? http.eventsService.invitationPdf(campusId, a.id) : http.eventsService.diplomaPdf(campusId, a.id);
		req.then(r => guardarBlob(r.data, `${tipo === "invitacion" ? "Invitacion" : "Diploma"}_${slug(a.name)}.pdf`))
			.catch(async e => notify(await blobErrorText(e), false));
	};
	const subir = (file: File | undefined) => {
		if (!file || !fotoDe) return;
		setBusy(true);
		http.eventsService.uploadPhoto(campusId, fotoDe.id, file)
			.then(() => { notify(S.fotoOk); reload(); })
			.catch(e => notify(errorText(e), false))
			.finally(() => { setBusy(false); setFotoDe(null); if (archivo.current) archivo.current.value = ""; });
	};
	const mostrarFoto = (a: EventAttendeeDTO) => http.eventsService.photo(campusId, a.id)
		.then(r => setVerFoto({ nombre: a.name, url: URL.createObjectURL(r.data) }))
		.catch(async e => notify(await blobErrorText(e), false));
	const mesa = (a: EventAttendeeDTO, v: string) => {
		const n = v.trim() === "" ? null : v.trim();
		if (n === (a.tableNo ?? null)) return;
		http.eventsService.updateAttendee(campusId, { attendeeId: a.id, tableNo: n }).then(reload).catch(e => notify(errorText(e), false));
	};
	const pagoManual = (a: EventAttendeeDTO, paid: boolean) =>
		http.eventsService.updateAttendee(campusId, { attendeeId: a.id, paid }).then(reload).catch(e => notify(errorText(e), false));

	const pago = (a: EventAttendeeDTO) => {
		if (a.charge) return <><div className="wau-num">{dinero(evento.currency, a.charge.total)}</div>
			<div className={a.paid ? "wau-sec" : "wau-oro"} style={{ fontSize: 12.5 }}>{a.paid ? S.pagado : S.porPagar + " " + dinero(evento.currency, a.charge.pending)}</div></>;
		if (a.kind === "externo" && !soloLectura && a.status === 1) {
			return <label style={{ display: "inline-flex", gap: 6, alignItems: "center", margin: 0, position: "static" }}>
				<input type="checkbox" checked={a.paid} onChange={e => pagoManual(a, e.target.checked)} />
				<span className={a.paid ? "" : "wau-oro"}>{a.paid ? S.pagado : S.porPagar}{a.price ? " " + dinero(evento.currency, a.price) : ""}</span></label>;
		}
		return <span className="wau-sec">{a.paid ? S.pagado : S.sinCobro}</span>;
	};
	const diploma = (a: EventAttendeeDTO) => {
		if (!a.diploma) return <span className="wau-sec">—</span>;
		if (a.diploma.ready) return <span className="wau-pastilla acento">{S.diplomaListo}</span>;
		return <span className="wau-pastilla oro" title={a.diploma.sessionsToRecover ? S.nPorReponer(a.diploma.sessionsToRecover) : undefined}>{S.falta(a.diploma.missing)}</span>;
	};

	return (
		<div className="wau-caja">
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 10 }}>
				<h3 style={{ margin: 0 }}>{S.tabs.asistentes} <span className="wau-sec wau-num">({S.vigentes(vigentes.length)})</span></h3>
				{soloLectura ? null : <button type="button" className="wau-btn p" onClick={() => setAgregar(true)}>{S.agregarAsistente}</button>}
			</div>
			<input ref={archivo} type="file" accept="image/jpeg,image/png,image/webp" style={{ display: "none" }} onChange={e => subir(e.target.files?.[0])} />
			{movil ? (
				/* En teléfono la tabla de nueve columnas se partía a media palabra: cada asistente pasa a una tarjeta. */
				<div>
					{evento.attendees.length === 0 ? <p className="wau-sec" style={{ margin: 0 }}>{S.sinAsistentes}</p> : evento.attendees.map((a, i) => (
						<div key={a.id} className="wau-tarjeta" style={a.status !== 1 ? { opacity: .55 } : undefined}>
							<div><span className="wau-num wau-sec">{i + 1}. </span><b>{a.name}</b></div>
							<div className="linea">{a.kindLabel}{a.isChild ? " · " + S.esNino : ""}{a.hostName ? " · " + S.invitaA(a.hostName) : a.identityCode ? " · " + a.identityCode : ""}</div>
							{a.status !== 1 ? <div className="wau-oro" style={{ fontSize: 12.5 }}>{a.statusLabel}</div> : null}
							<div className="wau-fila" style={{ marginTop: 6, alignItems: "center" }}>
								<span className="linea">{S.colMesa}</span>
								{soloLectura || a.status !== 1 ? <span>{a.tableNo ?? "—"}</span> :
									<input className="wau-entrada wau-num" maxLength={10} style={{ width: 70, padding: "3px 6px" }} aria-label={S.colMesa} defaultValue={a.tableNo ?? ""} onBlur={e => mesa(a, e.target.value)} />}
							</div>
							<div style={{ marginTop: 6 }}>{pago(a)}</div>
							<div style={{ marginTop: 6 }}>{diploma(a)}</div>
							<div className="linea wau-num" style={{ marginTop: 6 }}>{S.colEntrada} {a.checkedInAt ? horaLocal(a.checkedInAt) : "—"}</div>
							<div className="wau-acciones" style={{ justifyContent: "flex-start", flexWrap: "wrap", marginTop: 8 }}>
								{a.hasPhoto ? <button type="button" className="wau-btn s mini" onClick={() => mostrarFoto(a)}>{S.verFoto}</button> : null}
								{soloLectura || a.status !== 1 ? null : <button type="button" className="wau-btn s mini" disabled={busy} onClick={() => { setFotoDe(a); archivo.current?.click(); }}>{a.hasPhoto ? S.cambiarFoto : S.subirFoto}</button>}
								{a.status === 1 ? <button type="button" className="wau-btn s mini" onClick={() => pdf(a, "invitacion")}>{S.invitacionPdf}</button> : null}
								{a.status === 1 && a.diploma ? <button type="button" className="wau-btn s mini" disabled={!a.diploma.ready} onClick={() => pdf(a, "diploma")}>{S.diplomaPdf}</button> : null}
								{!soloLectura && a.status === 1 ? <button type="button" className="wau-btn s mini" onClick={() => setBaja(a)}>{S.baja}</button> : null}
							</div>
						</div>
					))}
				</div>
			) : (
			<div className="wau-tabla">
				<table>
					<thead><tr><th className="der">{S.colNo}</th><th>{S.colNombre}</th><th>{S.colTipo}</th><th>{S.colMesa}</th><th className="der">{S.colPago}</th><th>{S.colFoto}</th><th>{S.colDiploma}</th><th>{S.colEntrada}</th><th></th></tr></thead>
					<tbody>
						{evento.attendees.length === 0 ? <tr><td colSpan={9} className="wau-sec" style={{ textAlign: "center", padding: 18 }}>{S.sinAsistentes}</td></tr> : evento.attendees.map((a, i) => (
							<tr key={a.id} style={a.status !== 1 ? { opacity: .55 } : undefined}>
								<td className="der wau-num">{i + 1}</td>
								<td><b>{a.name}</b><div className="wau-sec" style={{ fontSize: 12.5 }}>{a.hostName ? S.invitaA(a.hostName) : a.identityCode || ""}</div></td>
								<td style={{ whiteSpace: "nowrap" }}>{a.kindLabel}{a.isChild ? " · " + S.esNino : ""}{a.status !== 1 ? <div className="wau-oro" style={{ fontSize: 12.5 }}>{a.statusLabel}</div> : null}</td>
								<td>{soloLectura || a.status !== 1 ? (a.tableNo ?? "—") :
									<input className="wau-entrada wau-num" maxLength={10} style={{ width: 70, padding: "3px 6px" }} aria-label={S.colMesa} defaultValue={a.tableNo ?? ""} onBlur={e => mesa(a, e.target.value)} />}</td>
								<td className="der">{pago(a)}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{a.hasPhoto ? <button type="button" className="wau-btn s mini" onClick={() => mostrarFoto(a)}>{S.verFoto}</button> : null}{" "}
									{soloLectura || a.status !== 1 ? null : <button type="button" className="wau-btn s mini" disabled={busy} onClick={() => { setFotoDe(a); archivo.current?.click(); }}>{a.hasPhoto ? S.cambiarFoto : S.subirFoto}</button>}
								</td>
								<td>{diploma(a)}</td>
								<td className="wau-num" style={{ whiteSpace: "nowrap", fontSize: 13 }}>{a.checkedInAt ? horaLocal(a.checkedInAt) : "—"}</td>
								<td style={{ whiteSpace: "nowrap", textAlign: "right" }}>
									{a.status === 1 ? <button type="button" className="wau-btn s mini" onClick={() => pdf(a, "invitacion")}>{S.invitacionPdf}</button> : null}{" "}
									{a.status === 1 && a.diploma ? <button type="button" className="wau-btn s mini" disabled={!a.diploma.ready} onClick={() => pdf(a, "diploma")}>{S.diplomaPdf}</button> : null}{" "}
									{!soloLectura && a.status === 1 ? <button type="button" className="wau-btn s mini" onClick={() => setBaja(a)}>{S.baja}</button> : null}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
			)}
			{agregar ? <AgregarModal campusId={campusId} evento={evento} onClose={() => setAgregar(false)} onDone={() => { setAgregar(false); notify(S.agregado); reload(); }} /> : null}
			{baja ? <PromptModal title={S.bajaTitulo(baja.name)} label={S.bajaNota} confirm={S.baja} optional busy={busy} onCancel={() => setBaja(null)}
				onConfirm={(nota) => {
					setBusy(true);
					http.eventsService.removeAttendee(campusId, baja.id, nota || undefined)
						.then(() => { setBaja(null); notify(S.bajaOk); reload(); })
						.catch(e => notify(errorText(e), false))
						.finally(() => setBusy(false));
				}} /> : null}
			{verFoto ? <Modal title={verFoto.nombre} onClose={() => { URL.revokeObjectURL(verFoto.url); setVerFoto(null); }}>
				<img src={verFoto.url} alt={verFoto.nombre} style={{ maxWidth: "100%", borderRadius: 8 }} />
			</Modal> : null}
		</div>
	);
};

export default AsistentesTab;
